import { FC } from 'react';

import { colors } from '~/constants/colors';

import { PageTitleContainer } from './styles';
import { TypographH1, TypographH3 } from '../typograph';

interface IPageTitle {
  readonly title: string;
  readonly description: string;
}

export const PageTitle: FC<IPageTitle> = ({ title, description }) => {
  return (
    <PageTitleContainer>
      <TypographH3
        uppercase
        bold
        color={colors.green}
        letterSpacing={5}
        size={14}
        lineHeight={18.24}
      >
        {title}
      </TypographH3>

      <TypographH1 bold uppercase size={40} color={colors.text_white}>
        {description}
      </TypographH1>
    </PageTitleContainer>
  );
};
